const c = {
  name: "WorldAfrica",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,3.7,17.3,4.3,17.3,5z"/>
		<path class="st0" d="M17.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C16.7,9.7,17.3,10.3,17.3,11z"/>
		<path class="st0" d="M21.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C20.7,9.7,21.3,10.3,21.3,11z"/>
		<path class="st0" d="M24,12.2c0.7,0,1.2-0.6,1.2-1.2S24.7,9.7,24,9.7c-0.7,0-1.2,0.6-1.2,1.2S23.3,12.2,24,12.2z"/>
		<path class="st0" d="M29.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C28.7,9.7,29.3,10.3,29.3,11z"/>
		<path class="st0" d="M32,12.2c0.7,0,1.2-0.6,1.2-1.2S32.7,9.7,32,9.7c-0.7,0-1.2,0.6-1.2,1.2S31.3,12.2,32,12.2z"/>
		<path class="st0" d="M15.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C14.7,12.7,15.3,13.3,15.3,14z"/>
		<path class="st0" d="M18,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S17.3,15.2,18,15.2z"/>
		<path class="st0" d="M23.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C22.7,12.7,23.3,13.3,23.3,14z"/>
		<path class="st0" d="M26,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S25.3,15.2,26,15.2z"/>
		<path class="st0" d="M31.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C30.7,12.7,31.3,13.3,31.3,14z"/>
		<path class="st0" d="M34,15.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2S33.3,15.2,34,15.2z"/>
		<path class="st0" d="M20,6.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,5.7,19.3,6.2,20,6.2z"/>
		<path class="st0" d="M25.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,3.7,25.3,4.3,25.3,5z"/>
		<path class="st0" d="M18,9.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,8.7,17.3,9.2,18,9.2z"/>
		<path class="st0" d="M31.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,6.7,31.3,7.3,31.3,8z"/>
		<path class="st0" d="M16,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,17.7,15.3,18.2,16,18.2z"
			/>
		<path class="st0" d="M21.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,15.7,21.3,16.3,21.3,17z"
			/>
		<path class="st0" d="M24,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,17.7,23.3,18.2,24,18.2z"
			/>
		<path class="st0" d="M29.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,15.7,29.3,16.3,29.3,17z"
			/>
		<path class="st0" d="M32,18.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,17.7,31.3,18.2,32,18.2z"
			/>
		<path class="st0" d="M23.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,18.7,23.3,19.3,23.3,20z"
			/>
		<path class="st0" d="M26,21.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,20.7,25.3,21.2,26,21.2z"
			/>
		<path class="st0" d="M31.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,18.7,31.3,19.3,31.3,20z"
			/>
		<path class="st0" d="M24,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,23.7,23.3,24.2,24,24.2z"
			/>
		<path class="st0" d="M29.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,21.7,29.3,22.3,29.3,23z"
			/>
		<path class="st0" d="M4,24.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C2.8,23.7,3.3,24.2,4,24.2z"/>
		<path class="st0" d="M23.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,24.7,23.3,25.3,23.3,26z"
			/>
		<path class="st0" d="M26,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,26.7,25.3,27.2,26,27.2z"
			/>
		<path class="st0" d="M31.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,24.7,31.3,25.3,31.3,26z"
			/>
		<path class="st0" d="M34,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,26.7,33.3,27.2,34,27.2z"
			/>
		<path class="st0" d="M25.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,27.7,25.3,28.3,25.3,29z"
			/>
		<path class="st0" d="M28,30.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.8,29.7,27.3,30.2,28,30.2z"
			/>
		<path class="st0" d="M33.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C32.7,27.7,33.3,28.3,33.3,29z"
			/>
		<path class="st0" d="M26,33.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.3-1.2-1.3c-0.7,0-1.2,0.6-1.2,1.3C24.8,32.7,25.3,33.2,26,33.2z"
			/>
		<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20c0,11-9,20-20,20S0,31,0,20z M2.1,21.2C2.7,30.6,10.5,38,20,38v0
			c9.9,0,18-8.1,18-18c0-2.8-0.6-5.4-1.8-7.8c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8
			c-0.2-0.3-0.5-0.7-0.7-1c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5C30.3,4.8,27,3,23.2,2.3
			c-0.1,0.5-0.6,1-1.2,1c-0.7,0-1.2-0.5-1.2-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.5,0c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0
			c0,0.7-0.6,1.2-1.2,1.2c-0.6,0-1-0.4-1.2-1c-8,1.4-14.2,8.2-14.8,16.5c0.7,0,1.2,0.6,1.2,1.2S2.7,21.2,2.1,21.2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldAfrica
};
